import * as React from 'react';
import { Outlet, Link } from 'react-router-dom';
import Header from './header/header';
import Sidebar from './sidebar/sidebar';


class Layout extends React.Component {
    render(){
      return (  
        <>
        <Header />
        <Sidebar/>
     
        <div class="page-loader" id="global-spinner">      
        
        <div class="loader" id="loader-1"></div>
        <div class="txt"><img src="assets/images/logo.svg" width="150"/></div>
        </div>
        </>
      )
    }
  }
  export default Layout;

